module.exports = __webpack_public_path__ + "img/12.4f726435.jpg";